import { HTMLAttributes, ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

export interface DrawerSqueezeZoneProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
}

/**
 * Layout helper that reserves space for a Compact-mode Drawer on wide screens (at or above the
 * Drawer's compact push breakpoint).
 *
 * Wrap the main page column with this component to opt into the Drawer's push-content behaviour.
 * On narrower viewports the Drawer overlays the content instead.
 */
export const DrawerSqueezeZone = ({ children, ...rest }: DrawerSqueezeZoneProps): ReactElement => (
  <Styled.DrawerSqueezeZoneWrapper {...rest}>{children}</Styled.DrawerSqueezeZoneWrapper>
)
